import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';

import { FullLayoutComponent } from './layouts/full/full-layout.component';
import { ContentLayoutComponent } from './layouts/content/content-layout.component';
import { UserLayoutComponent } from './layouts/user-layout/user-layout.component';

import { FULL_ROUTES } from './shared/routes/full-layout.routes';
import { CONTENT_ROUTES } from './shared/routes/content-layout.routes';
import { USER_ROUTES } from './shared/routes/user-layout.routes';

import { AuthGuard } from './shared/auth/auth-guard.service';
import { AuthUserGuard } from './shared/auth/auth-user.guard.service';
import { LoginSuperadminComponent } from './pages/login-superadmin/login-superadmin.component';
import { HomeComponent } from './pages/home/home.component';
// import { LoginUserComponent } from './pages/login-user/login-user.component';
import { LoginAdminComponent } from './pages/login-admin/login-admin.component';
import { RegisterComponent } from './pages/register/register.component';
import { ErrorPageComponent } from './pages/error/error-page.component';
import { BookingComponent } from './shared/booking/booking.component';
import { TicketViewComponent } from './shared/ticket-view/ticket-view.component';
import { EventViewComponent } from './pages/event-view/event-view.component';
import { SigninComponent } from './pages/signin/signin.component';
import { OrderingComponent } from './shared/ordering/ordering.component';

const appRoutes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  {
    path: 'home',
    // redirectTo: 'home',
    component: HomeComponent
    // pathMatch: 'full'
  },
  {
    path: 'login/superadmin',
    component: LoginSuperadminComponent
  },
  {
    path: 'login',
    component: SigninComponent
  },
  {
    path: 'rock-charity-live-in-phuket',
    component: EventViewComponent,
    data: { eventId: 'EMl7EK7fpdRE7fwum4Uw' }
  },
  {
    path: 'turtle-fun-run-14-shirt',
    component: EventViewComponent,
    data: { eventId: 'h1y2saYNwpgOLqBABL2n' }
  },
  {
    path: 'login/admin',
    component: LoginAdminComponent
  },
  {
    path: 'register',
    component: RegisterComponent
  },
  {
    path: 'superadmin/booking',
    component: BookingComponent
  },
  {
    path: 'admin/ordering',
    component: OrderingComponent
  },
  {
    path: 'ticket',
    component: TicketViewComponent
  },
  {
    path: '',
    component: UserLayoutComponent,
    data: { title: 'user Views' },
    children: USER_ROUTES,
    canActivate: [AuthUserGuard]
  },
  {
    path: '',
    component: FullLayoutComponent,
    data: { title: 'full Views' },
    children: FULL_ROUTES,
    canActivate: [AuthGuard]
  },
  {
    path: '',
    component: ContentLayoutComponent,
    data: { title: 'content Views' },
    children: CONTENT_ROUTES,
    canActivate: [AuthGuard]
  },
  { path: '**', component: ErrorPageComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
